import { render } from "./PostResumeView.vue?vue&type=template&id=01c91e62"
import script from "./PostResumeView.vue?vue&type=script&lang=js"
export * from "./PostResumeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__